import HeroContent from 'components/HeroConsolidated/shared/HeroContent';
import HeroCTA from 'components/HeroConsolidated/shared/HeroCTA';
import { HeroImage } from 'components/HeroConsolidated/shared/HeroImage';
import HeroWrapper from 'components/HeroConsolidated/shared/HeroWrapper';
import { HeroConsolidatedProps } from 'libs/contentful/props';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { cn } from 'utils/styles';
import RichTextCopy from '../shared/RichTextCopy/RichTextCopy';

const HeroPillarVariant = ({
  sys,
  color,
  headline,
  copy,
  cta,
  scrollCta,
  disclaimers,
  margins,
  sectionName,
  desktopMedia,
  mobileMedia,
  headingLevel,
  enrollmentUrl,
}: HeroConsolidatedProps) => {
  const primaryMedia = desktopMedia ?? mobileMedia;
  const hasMedia = primaryMedia != null;

  const media = primaryMedia && <HeroImage media={primaryMedia} mobileMedia={mobileMedia} />;

  return (
    <HeroWrapper
      testId={'pillarVariant'}
      color={color}
      margins={margins}
      sectionName={sectionName}
      className={'py-16 sm:pb-20 sm:pt-[120px]'}
      innerClassName={'flex sm:flex-col items-center text-center sm:gap-6'}>
      <HeroContent headline={headline} sys={sys} headingLevel={headingLevel} />

      <HeroCTA
        sys={sys}
        cta={cta}
        scrollCta={scrollCta}
        disclaimers={disclaimers}
        enrollmentUrl={enrollmentUrl}
        image={media}
        className="w-fit -mt-4"
      />

      <div className="p-8 lg:p-10 mt-6 flex flex-col items-center gap-6 border-[1.5px] border-(--btn-outline) rounded-[20px]">
        <div className="text-2xl font-semibold font-sans">
          <RichTextCopy copy={copy} />
        </div>

        {hasMedia && (
          <div className={cn('hero-media-container h-full w-full grow-0')} data-testid="hero-media-container">
            <div className={cn(`relative flex`)} {...liveUpdateAttrs(sys?.id, 'desktopMedia')}>
              {media}
            </div>
          </div>
        )}
      </div>
    </HeroWrapper>
  );
};

export default HeroPillarVariant;
